/*global APP_ENV, JS_DEBUG, JS_DEBUG_LOG */

const toBool = val => {
  const retVal = { 'false': false, 'true': true }[val]
  return _.isBoolean(retVal) ? retVal : val
}

const isNil = (v) => v === undefined || v === null

export const initDebugLog = () => {
  const isLocal = APP_ENV === 'local'
  const jsDebugLog = toBool(JS_DEBUG_LOG)
  const jsDebug = toBool(JS_DEBUG)
  const needsLog = jsDebugLog === true ||
    (isNil(jsDebugLog) && jsDebug !== false && isLocal) ||
    (isNil(jsDebugLog) && jsDebug === true)
  const unfn = () => {}

  // eslint-disable-next-line no-console
  return needsLog && console && console.log || unfn
}

export default initDebugLog
